module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-6-39bd43ba9786b59f01cdfcf00c5a70ac.svg";